import { z } from 'zod';
import { DEFAULT_TZ, isValidTz } from '../core/time';
import { HexColorZ, IdZ, NameZ, TsZ } from './common';

/**
 * Crew settings live in the `settings` key-value table (value is JSON text). One crew per
 * deployment. Keys and defaults below are the full v1 list; 0001_init seeds the defaults.
 */
export const SETTINGS_DEFAULTS = {
  'crew.name': 'TTS',
  crew_tz: DEFAULT_TZ,
  team_primary: '#cb94c2',
  team_secondary: '#000000',
  'sessions.go_live_checkins': 4,
  'sessions.wrap_idle_hours': 3,
  'sessions.horizon_weeks': 8,
  'sessions.attendance_public': 1,
  'gamelab.enabled': 1,
  /** ADDENDUM A8: aliases (P1..Pn) by default; the owner can switch to names. */
  'gamelab.shareNames': 'aliases',
  'gamelab.court': { hoops: 1, balls: 1, cones: 0, notes: '' },
} as const;
export type SettingKey = keyof typeof SETTINGS_DEFAULTS;

export const TzZ = z.string().refine(isValidTz, 'Unknown time zone');

export const CrewZ = z.object({
  name: NameZ,
  tz: TzZ,
  teamPrimary: HexColorZ,
  teamSecondary: HexColorZ,
  ownerMemberId: IdZ.nullable(),
  memberCount: z.number().int().nonnegative(),
  playerCount: z.number().int().nonnegative(),
  createdAt: TsZ.nullable(),
});
export type Crew = z.infer<typeof CrewZ>;

export const CrewPatchZ = z
  .object({
    name: NameZ,
    tz: TzZ,
    teamPrimary: HexColorZ,
    teamSecondary: HexColorZ,
  })
  .partial();
